// =============================================================================
//  Copyright : 2023 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : workshop parts
// =============================================================================
// ---Third-party imports
import React from 'react';
// ---Framework imports
import { loadLazy } from 'uix/parts';
// ---Exports
export const WorkshopList = loadLazy(()=>import(/* webpackChunkName: 'workshop' */ './list'));
export const WorkshopViewer = loadLazy(()=>import(/* webpackChunkName: 'workshop' */ './viewer'));
export const WorkshopUser = loadLazy(()=>import(/* webpackChunkName: 'workshop' */ './user'));
export const WorkshopTools = loadLazy(()=>import(/* webpackChunkName: 'workshop' */ './tools'));
